export const ROUTES = {
  NOT_FOUND: "*",
  NOT_FOUND_PAGE: "/404",
  INDEX: "/",
  FOR_YOU: "/feed",
  SEARCH: "/search",
  ACTORS: "/actors",
  FILTERS: "/filters",
  FILTERS_FOR_LIST: "/filters-list",
  FILTERS_FOR_FAVOURITES: "/filters-favourites",
  HERO: "/welcome",
  MOBILE_PRE_LOGIN: '/pre-login',
  DETAILS: "/details",
  LOGIN: "/login",
  CONFIRMATION: '/confirmation',
  MORE: "/more",
  COOPERATION: "/cooperation",
  ABOUT_US: "/about-us",
  SUPPORT: "/support",
  AGREEMENT: "/agreement",
  PROFILE: '/profile',
  ACTIVITY: "/activity",
  USERS: "/users",
  PRE_PAYMENT: "/pre-payment",
  PAY: "/pay",
  GREETINGS: "/greetings",
  DISCOUNT: "/discount",
  MOBILE_ACCOUNT_SETTINGS: "/mobile_account_settings",
  MOBILE_PAYMENT_DETAILS: "/mobile_payment_details",
  SUPPORT_CHAT: "/support-chat",
  FAVOURITES: "/favourites",
  GID: "/guide",
  ROOM: "/share",
};
